<template>
  <el-dialog title="Downloaded Files" :visible.sync="showDownloadVis" :before-close="handleClose" width="70%">
    <el-table :data="gridData" max-height="250" stripe>
      <el-table-column prop="fileName" label="File Name" width="200">
        <template slot-scope="scope">
          <i class="el-icon-download download-icon" @click="downloadClick(scope.row)"></i> {{ scope.row.fileName }}
        </template>
      </el-table-column>
      <el-table-column prop="fileSize" label="File Size"></el-table-column>
      <el-table-column prop="kccTitle" label="KCC Title"></el-table-column>
      <el-table-column prop="uploadBy" label="Uploaded by"></el-table-column>
      <el-table-column prop="uploadTime" label="Uploaded time"></el-table-column>
      <el-table-column prop="downloadBy" label="Downloaded by"></el-table-column>
      <el-table-column prop="downloadTime" label="Downloaded time"></el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
  export default {
    name: "downloadFileDialog",
    components: {},
    props: {
      showDownloadVis: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        gridData: [
          {
            fileName: '法定审计报告报表（19）.pdf',
            fileSize: '124KB',
            kccTitle: 'PBC',
            uploadBy: 'Elaine Wang',
            uploadTime: '2022-11-22 13:30:54',
            downloadBy: 'client5',
            downloadTime: '2022-11-22 13:30:54',
          },
          {
            fileName: '法定审计报告报表（19）.pdf',
            fileSize: '124KB',
            kccTitle: 'PBC',
            uploadBy: 'Elaine Wang',
            uploadTime: '2022-11-22 13:30:54',
            downloadBy: 'client5',
            downloadTime: '2022-11-22 13:30:54',
          },
          {
            fileName: '法定审计报告报表（19）.pdf',
            fileSize: '124KB',
            kccTitle: 'PBC',
            uploadBy: 'Elaine Wang',
            uploadTime: '2022-11-22 13:30:54',
            downloadBy: 'client5',
            downloadTime: '2022-11-22 13:30:54',
          },
          {
            fileName: '法定审计报告报表（19）.pdf',
            fileSize: '124KB',
            kccTitle: 'PBC',
            uploadBy: 'Elaine Wang',
            uploadTime: '2022-11-22 13:30:54',
            downloadBy: 'client5',
            downloadTime: '2022-11-22 13:30:54',
          },
        ],
      }
    },
    mounted() {
    },
    methods: {
      handleClose() {
        this.$emit("close")
      },
      downloadClick(data) {
        
      }
    }
  }
</script>
<style scoped>
  .download-icon {
    color: #3879eb;
    font-weight: bold;
  }
</style>
